export var CallType;
(function (CallType) {
    CallType["audio"] = "audio";
    CallType["video"] = "video";
    CallType["api"] = "api";
})(CallType || (CallType = {}));
export const breakpoints = { xs: 0, sm: 479, md: 744, lg: 1025, xl: 2000 };
export var ParticipantActivities;
(function (ParticipantActivities) {
    ParticipantActivities[ParticipantActivities["Join"] = 0] = "Join";
    ParticipantActivities[ParticipantActivities["Leave"] = 1] = "Leave";
    ParticipantActivities[ParticipantActivities["Update"] = 2] = "Update";
})(ParticipantActivities || (ParticipantActivities = {}));
//# sourceMappingURL=types.js.map